(() => {
 'use strict';
 const initialize = root => {
  root.querySelectorAll('img[data-bike-fallback]').forEach(image => {
   if (image.dataset.fallbackReady) return;
   image.dataset.fallbackReady = 'true';
   const fallback = () => {
    if (image.dataset.fallbackUsed) return;
    image.dataset.fallbackUsed = 'true';
    image.src = image.dataset.bikeFallback;
   };
   image.addEventListener('error',fallback);
   if (image.complete && !image.naturalWidth) fallback();
  });
  const sections = root.matches?.('[data-lv-bike-product]') ? [root] : root.querySelectorAll('[data-lv-bike-product]');
  sections.forEach(section => {
   if (section.dataset.bikeReady) return;
   const form = section.querySelector('[data-lv-bike-form]');
   const source = section.querySelector('[data-bike-variant]');
   if (!form || !source) return;
   section.dataset.bikeReady = 'true';
   const variant = JSON.parse(source.textContent);
   const quantity = form.querySelector('[name="quantity"]');
   const id = form.querySelector('[name="id"]');
   const add = form.querySelector('[name="add"]');
   const label = add.querySelector('[data-add-text]');
   const status = section.querySelector('[data-product-status]');
   const currency = section.dataset.currency;
   const formatter = new Intl.NumberFormat('en-US',{style:'currency',currency,currencyDisplay:'narrowSymbol'});
   const price = amount => `${formatter.format(amount / 100)} ${currency}`;
   const minimum = Math.max(1,Number(variant.minimum) || 1);
   const step = Math.max(1,Number(variant.step) || 1);
   const limits = [variant.max,variant.inventory].filter(n => n !== null && Number.isFinite(Number(n))).map(Number);
   const maximum = limits.length ? Math.min(...limits) : Infinity;
   let busy = false;
   // Always use the current one-bike SKU selected in Liquid, including on stale ?variant= URLs.
   id.value = String(variant.id);
   const update = (normalize = true) => {
    quantity.min = minimum;
    quantity.step = step;
    if (Number.isFinite(maximum)) quantity.max = Math.max(0,maximum);
    else quantity.removeAttribute('max');
    let count = Number(quantity.value);
    if (normalize) {
     count = Number.isFinite(count) ? Math.max(minimum,Math.trunc(count)) : minimum;
     count = minimum + Math.floor((count - minimum) / step) * step;
     if (maximum >= minimum) count = Math.min(count,minimum + Math.floor((maximum - minimum) / step) * step);
     quantity.value = count;
    }
    const valid = Number.isInteger(count) && count >= minimum && count <= maximum && (count - minimum) % step === 0;
    section.querySelector('[data-product-price]').textContent = price(variant.price);
    section.querySelector('[data-order-total]').textContent = price(variant.price * (Number.isFinite(count) && count > 0 ? count : 0));
    section.querySelector('[data-order-count]').textContent = `${Math.max(0,count || 0)} ${count === 1 ? section.dataset.countOne : section.dataset.countMany}`;
    add.disabled = busy || !variant.available || !valid;
    label.textContent = busy ? section.dataset.adding : !variant.available ? section.dataset.soldOut : section.dataset.addLabel;
    section.querySelectorAll('[data-quantity-change]').forEach(button => {
     button.hidden = false;
     button.disabled = busy || !variant.available || (Number(button.dataset.quantityChange) < 0 ? count <= minimum : count + step > maximum);
    });
   };
   section.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click',() => {
    quantity.value = (Number(quantity.value) || minimum) + Number(button.dataset.quantityChange) * step;
    status.textContent = '';
    update();
   }));
   quantity.addEventListener('input',() => update(false));
   quantity.addEventListener('change',() => update());
   const thumbnails = section.querySelector('[data-gallery-thumbs]');
   if (thumbnails) thumbnails.hidden = false;
   section.querySelectorAll('[data-gallery-target]').forEach(button => button.addEventListener('click',() => {
    section.querySelectorAll('[data-gallery-panel]').forEach(panel => {panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryTarget;});
    section.querySelectorAll('[data-gallery-target]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
   }));
   form.addEventListener('submit',async event => {
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    if (busy) return;
    update();
    if (add.disabled || !form.reportValidity()) return;
    id.value = String(variant.id);
    const data = new FormData(form);
    busy = true;
    form.setAttribute('aria-busy','true');
    status.textContent = '';
    update(false);
    try {
     const response = await fetch(section.dataset.addUrl,{method:'POST',body:data,headers:{Accept:'application/json'},credentials:'same-origin'});
     if (!response.ok) {
      status.textContent = response.status === 422 ? section.dataset.stockError : section.dataset.error;
      return;
     }
     location.assign(section.dataset.cartUrl);
    } catch {
     status.textContent = section.dataset.networkError;
    } finally {
     busy = false;
     form.removeAttribute('aria-busy');
     update(false);
    }
   });
   update();
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(document));
 else initialize(document);
 document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
